<template>
    <div class="article-search">
        <div class="search-top">
            <div>条文检索</div>
            <el-input class="search-input" type='text' v-model="searchName"></el-input>
            <el-button  type="primary" >检索</el-button>
        </div>
        <div class="article-info">
            <el-collapse v-model="activeNames" @change="handleChange"> 
                <el-collapse-item v-for="(item,index) in articleInfoList" :key="index" :name="item.type">
                    <template slot="title">
                        <div class="info-tit">{{item.tit}}
                            <!-- <i class="header-icon el-icon-caret-bottom"></i>-->
                        </div> 
                    </template>
                    <ul class="info-num-list" v-if="item.type<3">
                        <li class="list" v-for="(list,index) in item.list" :key="index">
                            <a href="javascript:;" @click.prevent="numClick(list)">{{list.val}}</a>
                        </li> 
                    </ul>
                    <ul class="info-label-list" v-else>
                        <li class="label-list" v-for="(list,index) in item.list" :key="index">
                            <div class="info-label">{{ list.label }}</div>
                            <div class="info-list">
                                <div class="list" v-for="(list,index) in list.listChild" :key="index">
                                    <a href="javascript:;" @click.prevent="numClick(item)">{{list}}</a>
                                </div>
                            </div>
                            
                        </li> 
                    </ul>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            searchName:'',
            activeNames: ['1'],
            articleInfoList:[
                {
                    tit:'条文编号',
                    type:'1',
                    list:[
                        {val:'第1-50条',tempArr:['1','50'],},
                        {val:'第51-100条',tempArr:['51','100'],},
                        {val:'第101-150条',tempArr:['101','150'],},
                        {val:'第151-200条',tempArr:['151','200'],},
                        {val:'第201-250条',tempArr:['201','250'],},
                        {val:'第251-300条',tempArr:['251','300'],},
                        {val:'第301-350条',tempArr:['301','350'],},
                        {val:'第351-398条',tempArr:['351','398'],}
                    ]
                },
                {
                    tit:'六经辨证',
                    type:'2',
                    list:[
                        {val:'太阳病',tempArr:[],},
                        {val:'阳明病',tempArr:[],},
                        {val:'少阳病',tempArr:[],},
                        {val:'太阴病',tempArr:[],},
                        {val:'少阴病',tempArr:[],},
                        {val:'厥阴病',tempArr:[],},
                        {val:'霍乱病',tempArr:[],},
                        {val:'阴阳易差后劳复病',tempArr:[],}
                    ]
                },
                {
                    tit:'症状索引',
                    type:'3',
                    list:[
                        {label:'B',listChild:["奔豚","必惊","不得安","不得汗","不得眠","不得卧寐","不恶寒","不恶寒而渴","不发热","不发热而恶寒","不汗出而烦躁","不结胸","不可转侧","不能得小汗出","不能发黄","不能卧","不能自转侧","不识人","不往来寒热","不欲近衣","不欲去衣"],},
                        {label:'C',listChild: ["潮热", "怵惕烦躁"]},
                        {label:'D',listChild:["大汗出", "但欲寐", "但欲卧", "但重", "盗汗", "动经", "短气", "多汗"]},
                        {label:'E',listChild:["恶风", "恶风寒", "恶寒", "恶寒汗出", "恶寒何故自罢", "恶热", "而反恶寒者"]},
                        {label:'F',listChild: ["发黄", "发狂", "发热", "发热不渴", "发热恶寒", "发热而厥", "发热而咳", "发热而利", "发热汗出而解", "烦渴", "烦躁", "烦躁不得眠", "烦躁欲死者", "烦躁者亦死", "反复颠倒", "反静", "反欲得衣者", "妇人伤寒", "妇人中风"]}, 
                        {label:'H',listChild:["汗不出", "汗出", "汗出必胀满", "汗出不彻", "汗出不恶寒", "汗出不烦", "汗出不解", "汗出不止", "汗出多", "汗出多而渴", "汗出而喘", "汗出而厥", "汗出而渴", "汗出濈濈然者", "汗出少", "汗从腰以下不得汗", "汗多", "汗家", "嘿嘿", "恍惚心乱", "霍乱"]},
                        {label:'J',listChild:["濈然微汗出", "结胸", "结胸证", "结胸证悉具", "经脉动惕", "经水适断", "经水适来", "惊狂", "惊痫"],},
                      
                        {label:'N',listChild:["难以屈伸", "衄", "衄家"]},
                        {label:'Q',listChild: ["其热不潮"]},
                        {label:'R',listChild: ["热入血室", "日晡所发热", "如见鬼状", "如狂", "如疟状"]},
                        {label:'S',listChild:  ["啬啬恶寒", "伤寒", "伤寒转系阳明", "少气", "身必黄", "身必痒", "身必重", "身不疼", "身大寒", "身大热", "身黄", "身黄如橘子色", "身凉", "身目为黄", "身热", "身热不去", "身如虫行皮中状", "身瞤动", "身疼", "身疼痛", "身体疼烦", "身体疼痛", "身体痛", "身体则枯燥", "身体重", "身痛不休", "身微热", "身为振振摇", "身无汗", "身有微热", "身重", "身灼热", "十余日振栗", "时发热", "时有微热", "嗜卧", "遂漏不止"],},
                        {label:'T',listChild:["惕而不安"]},
                        {label:'W',listChild: [ "往来寒热", "微恶寒", "微发热", "微热", "未发热", "温病", "无大热", "无汗", "无汗而喘", "无汗而小便利", "无热证者", "无血"]},
                        {label:'X',listChild: ["下血", "下重", "消渴", "小结胸病", "协热而利", "协热利", "泄利下重", "形似疟", "形作伤寒","翕翕发热","翕翕如有热状"]},
                        {label:'Y',listChild:["夜而安静", "一身及目悉黄", "一身手足尽热", "阴疼", "痈脓", "瘀血", "余处无汗"],},
                        {label:'Z',listChild: ["燥烦", "躁", "躁无暂安时者", "振寒", "振栗汗出而解", "蒸蒸而振", "蒸蒸发热", "漐漐汗出", "中风", "中风发热", "中寒", "昼日烦躁不得眠", "昼日明了", "自汗出而恶热"]},
                    ] 
                },
                {
                    tit:'方剂检索',
                    type:'4',
                    list:[
                        {label:'B',listChild:["白虎汤", "白虎加人参汤", "半夏泻心汤", "半夏散及汤", "白头翁汤", "白散", "白通汤", "白通加猪胆汁汤"],},
                        {label:'C',listChild: ["柴胡桂枝汤", "柴胡加芒硝汤", "柴胡加龙骨牡蛎汤", "柴胡桂枝干姜汤", "赤石脂禹余粮汤"]},
                        {label:'D',listChild:["大柴胡汤", "大承气汤", "大青龙汤", "大陷胸汤", "大陷胸丸", "抵当汤", "抵当丸", "大黄黄连泻心汤", "当归四逆汤", "当归四逆加吴茱萸生姜汤"],},
                        {label:'F',listChild: ["附子汤", "附子泻心汤", "茯苓甘草汤", "茯苓四逆汤", "茯苓桂枝白术甘草汤", "茯苓桂枝甘草大枣汤"],},
                        {label:'G',listChild:["桂枝汤", "葛根汤", "葛根黄芩黄连汤", "甘草汤", "甘草泻心汤", "桂枝去芍药汤", "桂枝人参汤", "桂枝二麻黄一汤", "桂枝二越婢一汤", "干姜附子汤", "干姜黄芩黄连人参汤", "葛根加半夏汤", "瓜蒂散", "桂加白术汤", "桂枝附子汤", "桂枝甘草龙骨牡蛎汤", "桂枝甘草汤", "桂枝加大黄汤", "桂枝加附子汤", "桂枝加葛根汤", "桂枝加桂汤", "桂枝加厚朴杏子汤", "桂枝加芍药生姜各一两人参三两新加汤", "桂枝加芍药汤", "桂枝麻黄各半汤", "桂枝去桂加茯苓白术汤", "桂枝去芍药加附子汤", "桂枝去芍药加蜀漆牡蛎龙骨救逆汤"],},
                        {label:'H',listChild: ["黄连汤", "黄连阿胶汤", "黄芩加半夏生姜汤", "厚朴生姜半夏甘草人参汤"],},
                        {label:'J',listChild:["桔梗汤"],},
                        {label:'K',listChild: ["苦酒汤"]},
                        {label:'L',listChild:["理中丸"],},
                        {label:'M',listChild: ["麻黄汤", "麻黄连轺赤小豆汤", "麻子仁丸", "麻黄附子甘草汤", "麻黄升麻汤", "麻黄细辛附子汤", "麻黄杏仁甘草石膏汤", "麻黄杏子甘草石膏汤", "蜜煎", "牡蛎泽泻散"],},
                        {label:'Q',listChild:["去桂加白术汤"],},
                        {label:'S',listChild: ["四逆散", "四逆汤", "芍药甘草汤", "芍药干姜汤", "生姜泻心汤", "芍药甘草附子汤", "四逆加人参汤", "十枣汤", "烧裈散"],},
                        {label:'T',listChild:["桃核承气汤", "桃花汤", "调胃承气汤", "通脉四逆加猪胆汤", "通脉四逆汤"],},
                        {label:'W',listChild: ["吴茱萸汤", "五苓散", "调胃承气汤", "乌梅丸"]},
                        {label:'X',listChild: ["小柴胡汤", "小青龙汤", "旋覆代赭汤", "小承气汤", "小建中汤", "小陷胸汤"],},
                        {label:'Y',listChild:["茵陈蒿汤"],},
                        {label:'Z',listChild:  ["真武汤", "炙甘草汤", "栀子豉汤", "栀子干姜汤", "栀子柏皮汤", "栀子甘草豉汤", "栀子厚朴汤", "栀子生姜豉汤", "枳实栀子豉汤", "猪肤汤", "猪苓汤", "竹叶石膏汤"]},
                    ]
                }
            ], 
        }   
    },
    methods:{
        handleChange(val) {
            // console.log(val);
        },
        numClick(item) { 
            let tempList = item.tempArr
            let html = "";
            let cont = tempList[0]; 
            // do{
            //     let startCont = parseInt(cont) - 10;
            //     let endCont = parseInt(cont) + 10;
            //     html += '<a style="font-size: 16px;height: 22px;line-height: 22px;border: 0px"  class="ljbz_title" onclick="searchShangHanLun('+"'".concat("".concat(startCont,"@",endCont),"@",cont,"'")+',4)">'+'第'+ cont+'条'+'</a>'
            //     cont++;
            // }while (cont>=tempList[0] && cont <= tempList[1])
            // $(".tiaoWenXuanZe").css('background-color','transparent')
            // $("#tiaoWenHaoZhanKai").html(html);
            // $(temp).css('background-color','#ccaa92')
        }
    }
}
</script>

<style lang="less" scoped>
.article-search{
    ::v-deep .el-input__inner{
        border:none;
    }
    ::v-deep .el-collapse{
        border:none;
    }
    .search-top{
        width: 1060px;
        margin: 20px auto;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .search-input{
            width: 860px;
            border:1px solid #386DE8;
            border-radius: 4px;
        }
    }
    .article-info{
        .info-tit{
            font-size: 18px;
            font-weight: bold;
            margin: 20px 0;
            padding-left: 20px;
            height: 24px;
            line-height: 24px;
            border-left: 6px solid #386DE8;
            color: #000;
        } 
        .info-num-list{
            display: flex;
            flex-wrap: wrap;
            margin-left: 140px;
            
        }
        .info-label-list{
            .label-list{
                display: flex;
                flex-wrap: wrap;
                .info-label{
                    width: 140px;
                    .label-txt();
                    color: #386DE8;
                }
                .info-list{
                    width: 1020px;
                }
            }
        }
        .list{
            .label-txt();
            height: 22px;
            width: 240px; 
            padding: 0 20px;
            border-left: 1px solid #386DE8;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            a{
                line-height: 22px;
                color: #545353;
                &:hover{
                    text-decoration: underline;
                }
            }
        }
        .label-txt{
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            margin: 14px 0; 
            line-height: 22px;
        }
    }

}
</style>